const Styles = {
  typography: {
    color: "#0000FF",
    marginBottom: 25,
    fontSize: 22,
    fontWeight: 500,
  },

  customTextFieldName: {
    width: "100%",
    marginBottom: "10px",
  },

  customTextFieldSecondary: {
    width: "85%",
    marginBottom: "10px",
  },
  customTextFieldSecondarytwo: {
    width: "85%",
    marginBottom: "10px",
    marginLeft: "40px",
  },
  customTextFieldNameField: {
    width: "100%",
    marginBottom: "10px",
  },
  gridContainerStyle: {
    marginTop: 8,
  },
  gridStyle: {
    marginTop: 12,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "3.75rem",
  },
  name: {
    gridColumn: "1 / 3",
  },

  icon: {
    cursor: "pointer",
  },
  div: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginTop: "12px",
  },
  nav: {
    height: "10%",
    display: "flex",
    gap: "20px",
    justifyContent: "flex-end",
  },
  attachments: {
    display: "flex",
    alignItems: "right",
    justifyContent: "flex-end;",
    gap: "5px",
    color: "red",
  },
  attachmentsLists: {
    background: "#f5f5f5",
    paddingLeft: "4px",
    borderRadius: "4px",
  },
  textContainer: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "160px",
    margin: "0 0",
  },
  attachmentsListsItems: {
    margin: "4px",
    display: "flex",
    alignItems: "center",
    color: "#15c",
  },
  tableTitle: {
    color: "rgb(97, 97, 97)",
    fontSize: "1.2rem",
    fontWeight: 500,
    marginBottom: "20px",
  },
  noteText: {
    width: "50%",
    margin: "auto auto 50px auto",
  },
  redAsterisk: {
    color: "red",
  },
};

export default Styles;
